import restService from "../../../restService";
import CampaignContext from "../../../contexts/CampaignContext";
import { useState, useContext, useEffect } from "react";
import { addDays } from "date-fns";
import DatePicker from "../../components/datepicker";

const RewardsDisbursement = () => {
  const [rewards, setRewards] = useState([]);
  // const [startDate, setStartDate] = useState(
  //   addDays(new Date(), -7).toISOString().slice(0, 10)
  // );
  const [endDate, setEndDate] = useState(new Date().toISOString().slice(0, 10));
  const [campaign] = useContext(CampaignContext);

  const [dateRange, setDateRange] = useState([
    {
      startDate: addDays(new Date(), -7),
      endDate: new Date(),
      key: "selection",
    },
  ]);

  // console.log(addDays(new Date(), -7).toISOString().slice(0, 10));

  useEffect(() => {
    getRewards();
  }, [dateRange]);

  const getRewards = async () => {
    try {
      const {
        data: { data },
      } = await restService.Dashboard.getRewards(
        campaign?.id,
        dateRange[0].startDate.toISOString().slice(0, 10),
        dateRange[0].endDate.toISOString().slice(0, 10)
      );
      if (data == null) {
        setRewards([]);
        // setRewards({});
      }
      setRewards(data);
    } catch (e) {
      console.log(e);
    }
  };

  const showActionMenu = (id) => {
    document.getElementById(id).classList.toggle("hidden");
  };
  return (
    <div className="w-full h-full mt-6 mb-3">
      <div className="flex md:flex-row flex-col gap-3 md:items-center justify-between">
        <div>
          <h2 className="md:text-xl text-lg md:ml-6">Reward Disbursement</h2>
        </div>
        <div className="px-4">
          <div className="w-full md:w-auto">
            <div className="flex md:w-auto w-full justify-end">
              <DatePicker
                emptyState={
                  <p className="flex items-center">
                    <span>
                      {" "}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-5 w-5 mr-1"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fillRule="evenodd"
                          d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                          clipRule="evenodd"
                        />
                      </svg>{" "}
                    </span>
                    Summary Period
                  </p>
                }
                state={dateRange}
                setState={setDateRange}
              />

              {/* </button> */}

              {(dateRange[0]?.startDate || dateRange[0]?.endDate) && (
                <button
                  className="flex items-center justify-between mx-0 px-0"
                  onClick={(e) => {
                    setDateRange([
                      {
                        startDate: "",
                        endDate: "",
                        key: "selection",
                      },
                    ]);
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6 "
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="red"
                    strokeWidth="2"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
      {rewards?.length < 1 ? (
        <div className="w-full flex justify-center mt-40 ">
          <img src={require("../../../assets/images/noData.svg")} alt="" />
        </div>
      ) : (
        // <div className="bg-white h-3/5 overflow-y-scroll  md:p-6 rounded-lg mt-4">
        //   <div className="grid grid-cols-2 grid-row-3 gap-6">
        //     {Object.entries(rewards).map(([key, value]) => (
        //       <div
        //         key={key}
        //         className="col-span-1 row-span-1 border   rounded-lg p-6 text-center "
        //       >
        //         <p className="text-3xl">{value}</p>
        //         <p className="mt-2 text-base text-[#848484] lowercase">
        //           {key.replace("_", " ")}
        //         </p>
        //       </div>
        //     ))}
        //   </div>
        // </div>

        <div className="bg-white  h-[85%] overflow-y-scroll  md:p-6 rounded-lg mt-4">
          <div className="grid grid-cols-2 grid-row-3 gap-6">
            {rewards?.map((value, index) => (
              <div
                key={index}
                className="col-span-1 row-span-1 border   rounded-lg p-6 text-center "
              >
                {value?.reward?.rewardType?.toLowerCase() === "airtime" ||
                value?.reward?.rewardType?.toLowerCase() === "momo" ? (
                  <p className="text-3xl">
                    <span className=" text-xs">GHS </span>
                    {Number(value?.amountWon)?.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                    })}
                  </p>
                ) : (
                  <p className="text-3xl">
                    {value?.amountWon?.toLocaleString(undefined, {
                      minimumFractionDigits: 0,
                    })}
                  </p>
                )}

                {value?.reward?.rewardType?.toLowerCase() === "airtime" ||
                value?.reward?.rewardType?.toLowerCase() === "momo" ? (
                  <p className="mt-2 text-base text-[#848484] capitalize">
                    <span className="text-[9px]">
                      {value.reward.amount}GHS{" "}
                    </span>
                    {value?.reward?.rewardType?.toLowerCase()}
                  </p>
                ) : (
                  <p className="mt-2 text-base text-[#848484] capitalize">
                    {value?.reward?.rewardType
                      ?.toLowerCase()
                      ?.replace("_", " ")}
                  </p>
                )}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default RewardsDisbursement;
